export const tableStyles = {
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '5px',
  tableLayout: 'fixed',
  width: '100%',
};
